//处理菜单权限公共工具方法

//  递归循环权限菜单 处理可显示渲染的菜单数据
const treeDataContains = function (data, name) {
  for (let j = 0, lens = data.length; j < lens; j++) {
    if (data[j].path == name) {
      return true;
    } else if (data[j].children && data[j].children.length > 0) {
      if (treeDataContains(data[j].children, name)) {
        return true;
      }
    }
  }

  return false
}

// 定义一个深复制函数  接收目标target参数
const deepClone =function (target) {
  // 定义一个变量
  let result;
  // 如果当前需要深拷贝的是一个对象的话
  if (typeof target === 'object') {
    // 如果是一个数组的话
    if (Array.isArray(target)) {
      result = []; // 将result赋值为一个数组，并且执行遍历
      for (let i in target) {
        // 递归克隆数组中的每一项
        result.push(deepClone(target[i]))
      }
      // 判断如果当前的值是null的话；直接赋值为null
    } else if(target===null) {
      result = null;
      // 判断如果当前的值是一个RegExp对象的话，直接赋值
    } else if(target.constructor===RegExp){
      result = target;
    }else {
      // 否则是普通对象，直接for in循环，递归赋值对象的所有值
      result = {};
      for (let i in target) {
        result[i] = deepClone(target[i]);
      }
    }
    // 如果不是对象的话，就是基本数据类型，那么直接赋值
  } else {
    result = target;
  }
  // 返回最终结果
  return result;
}

//  递归循环权限菜单 处理可显示渲染的菜单数据,childrenFlag是二级菜单，如果path为空则删除本身，同时下级也会被删除，不显示菜单
let treeData = function (data, j,childrenFlag) {
  data.id = j + ""
  data.name = data.permName
  data.icon = data.permCode
  if (data.children && data.children.length > 0) {
    for (let i = 0, lens = data.children.length; i < lens; i++){
      if(!childrenFlag && (data.children[i].hasOwnProperty('path')&&data.children[i].path==""||!data.children[i].hasOwnProperty('path'))){
        data.children.splice(i, 1);
        i=i-1
        lens = lens-1
        continue;
      }else{
        treeData(data.children[i], j + "-" + (i + 1),true)
      }
    }

  }
}

// 判断是否拦截页面
let goToPage = function (menuList, to, from, next) {
  if (treeDataContains(menuList, to.name)) {
    next()
  } else {
    if(from.fullPath=="/"){
      next("courseList")
    }else{
      next(from.fullPath)
    }
  }
}


export default {
  treeData,
  deepClone,
}